import { render, staticRenderFns } from "./LocalImageUploader.vue?vue&type=template&id=70a68a0b&scoped=true"
import script from "./LocalImageUploader.vue?vue&type=script&lang=js"
export * from "./LocalImageUploader.vue?vue&type=script&lang=js"
import style0 from "./LocalImageUploader.vue?vue&type=style&index=0&id=70a68a0b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "70a68a0b",
  null
  
)

export default component.exports